import { createTheme, type Theme } from '@mui/material/styles'
import type { ResolvedTheme } from './types'

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#7B5B3A',
      light: '#A8876A',
      dark: '#5C3D22',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#E8DDD0',
      paper: '#F0E6D9',
    },
    text: {
      primary: '#3E2723',
      secondary: '#5D4037',
      disabled: '#8D6E63',
    },
    divider: 'rgba(62, 39, 35, 0.12)',
    action: {
      hover: 'rgba(62, 39, 35, 0.05)',
      selected: 'rgba(62, 39, 35, 0.08)',
    },
    error: {
      main: '#C62828',
      light: '#EF5350',
      dark: '#8E0000',
    },
    warning: {
      main: '#AD4E00',
      light: '#E58A3B',
      dark: '#7A3700',
    },
    success: {
      main: '#2E7D32',
      light: '#60AD5E',
      dark: '#005005',
    },
    info: {
      main: '#1B6B5A',
      light: '#4DA698',
      dark: '#004D40',
    },
  },
  typography: {
    fontFamily: '"Fira Code", "JetBrains Mono", "SF Mono", "Monaco", "Consolas", monospace',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(62, 39, 35, 0.10)',
        },
      },
    },
  },
})

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#3b82f6',
      light: '#60a5fa',
      dark: '#2563eb',
      contrastText: '#ffffff',
    },
    background: {
      default: '#1a1a1a',
      paper: '#2d2d2d',
    },
    text: {
      primary: '#fafafa',
      secondary: '#9ca3af',
    },
    divider: 'rgba(255, 255, 255, 0.08)',
    action: {
      hover: 'rgba(255, 255, 255, 0.06)',
      selected: 'rgba(255, 255, 255, 0.12)',
    },
  },
  typography: {
    fontFamily: '"Fira Code", "JetBrains Mono", "SF Mono", "Monaco", "Consolas", monospace',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#2d2d2d',
          backgroundImage: 'none',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#2d2d2d',
          backgroundImage: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#2d2d2d',
          border: '1px solid rgba(255, 255, 255, 0.08)',
        },
      },
    },
  },
})

export function getThemeByMode(mode: ResolvedTheme): Theme {
  return mode === 'dark' ? darkTheme : lightTheme
}
